import { useAuthFetch } from "@/hooks/data/useAuthFetch";
import { officeQueryKeys } from "@/hooks/data/v2/query-keys";
import { parseResponse } from "@/lib/query-helper";
import { APIResponse, PaginatedResponse, SearchFilter } from "@simplerealtybits/srb-types";
import { Office } from "@t/Office";
import { useQuery } from "@tanstack/react-query";

export function useGetOfficesByFilter(filter: SearchFilter) {
    const authFetch = useAuthFetch();

    const getOfficesByFilter = async (): Promise<PaginatedResponse<Office>> => {
        return await authFetch("/api/v1/offices/getByfilter", {
            method: "POST",
            body: JSON.stringify(filter),
        }).then((response) => response.json());
    };

    const getOfficesByFilterQueryOptions = () => ({
        queryKey: officeQueryKeys.getByFilter(filter),
        queryFn: () => getOfficesByFilter(),
        enabled: !!filter,
        select: (data: PaginatedResponse<Office>) => data.data,
    });

    return useQuery(getOfficesByFilterQueryOptions());
}

export function useGetOfficeById(officeId: number) {
    const authFetch = useAuthFetch();

    const queryFn = async (): Promise<APIResponse<Office>> => {
        const res = await authFetch(`/api/v1/offices/${officeId}`, {
            method: "GET",
        });
        return await parseResponse<Office>(res);
    };

    return useQuery({
        queryKey: officeQueryKeys.getById(officeId),
        queryFn,
        enabled: !!officeId,
        select: (data: APIResponse<Office>) => data.data,
    });
}
